module.exports = __webpack_public_path__ + "img/construction-repair.05792f9a.jpg";